<template>
    <div class="qaItem">
        <h3 class="qaTitle" v-text="itemData.question_title"></h3>
        <hr>
        <div class="qaContent" :style="{'height':height}" ref="cbox">
            <div class="content_body" ref="cbody" v-html="itemData.question_content"></div>
        </div>
        <div v-if="showBtn" class="show_more" @click="showMore">
            {{limited?$t('service.unfoldMore'):$t('service.packUp')}}
            <img src="../../images/arrow_down_circle.svg" :class="{reverse: !limited}">
        </div>

    </div>
</template>

<script>
    export default {
        name: 'qaItem',
        props: [
            'itemData'
        ],
        data() {
            return {
                limited: true,
                showBtn: false,
                fullHeight: "",
                height: ".64rem"
            };
        },
        methods: {
            showMore(){
                this.updateBox();
                this.limited = !this.limited;
                if (!this.limited) {
                    this.height = this.fullHeight;
                }else{
                    this.height = ".64rem";
                }
            },
            updateBox (){
                if(this.$refs.cbox&&this.$refs.cbody){
                    let h_box = this.$refs.cbox.offsetHeight;
                    let h_body = this.$refs.cbody.offsetHeight;
                    if (h_box<h_body) {
                        this.showBtn = true;
                    }
                    this.fullHeight = 0.64/h_box*h_body + "rem";
                }
            },
            getAllimgs (){
                var _this = this;
                var imgs = this.$refs.cbody.getElementsByTagName('img');
                var ifAllLoaded = function(){
                    var res = true;
                    for (let i = 0; i < imgs.length; i++) {
                        if(!imgs[i].loaded){
                            res = false;
                        }                   
                    }
                    return res;
                }
                for (let j = 0; j < imgs.length; j++) {
                    imgs[j].loaded = false;
                    imgs[j].addEventListener('load', function(){
                        imgs[j].loaded = true;
                        if(ifAllLoaded()){
                            _this.updateBox();
                        }
                    });
                }
            }
        },
        created() {},
        mounted() {
            
            // console.log("##",this.$refs.cbox,this.$refs.cbody)
            // setTimeout(() => {
            //     this.updateBox();
            // }, 1000);
            this.getAllimgs();
            this.$nextTick(() => {
                this.updateBox();
            });
            
        }
    };
</script>

<style lang="scss" scoped>
    
    $cl_green : #50BBE5;
    $cl_dark : #444444;
    
    .qaItem{
        background-color: #F2F2F2;
        border-radius: .12rem;
        padding: .12rem .12rem 0;
        margin-bottom: .1rem;        
        h3{
            font-size: .14rem;
            color: $cl_dark;
            line-height: .19rem;
            margin: 0 0 .12rem;
        }
        hr{
            margin: .12rem 0;
            border: 0;
            height: .01rem;
            background-color: #DDDDDD;
        }
        /deep/ .qaContent{
            font-size: .12rem;
            line-height: .16rem;
            color: #666666;
            overflow: hidden;
            height: .64rem;
            transition: all .2s;
            margin-bottom: .12rem;
            .content_body{
                > *:nth-child(1) {
                    margin-top: 0;
                }
                img{
                    display: block;
                    max-width: 100%;
                }
            }
        }
        .show_more{
            font-size: .1rem;
            color: #999999;
            height: .34rem;
            line-height: .34rem;
            margin-top: .12rem;
            text-align: center;
            border-top: 1px dashed #DDDDDD;
            cursor: pointer;
            img{
                width: .08rem;
                transition: transform 0.3s;
                &.reverse {
                    transform: rotate(180deg);
                }
            }
        }
    }
</style>
